import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
export const placementTypeSchema = z.enum(['before', 'after', 'within']);
export const placementPayloadSchema = z.object({
    placementType: placementTypeSchema,
    relativeEntityId: uuidish,
});
/**
 * Convert a JSON object to a PlacementPayload
 * @param placementPayload
 * @throws IllegalArgumentError if the placementPayload is not a valid PlacementPayload
 * @returns PlacementPayload
 */
export function toPlacementPayload(placementPayload) {
    const result = placementPayloadSchema.safeParse(placementPayload);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid PlacementPayload object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=placement-payload.js.map